import React, { useEffect, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PrevBtn, NextBtn, PaginationWrapper, Btn } from "../Styles/PageStyles";
import Images from "../../Images";
import tw from "tailwind-styled-components";
import { PaginationLimit } from "../../Config";
import { useNavigate } from "react-router-dom";
import { GoDownload } from "react-icons/go";
import { formatAmount, getDueTypeLabel, hasPermission, truncateText } from "../../helpers";
import moment from "moment";
import { getModeName } from "../../helpers";
import { IoEye } from "react-icons/io5";
import { MdRestore } from "react-icons/md";
import { IoMdMore } from "react-icons/io";
import { useSelector } from "react-redux";
import TenantMiniProfile from "../Common/TenantMiniProfile";
import Tooltip from "../Tooltip";

const TransactionTable = ({
  apiData,
  setSelectedData,
  setViewDetail,
  userType,
  setIsRestorePayment
}) => {
  const storageKey = `tenant_collections_page`;
  const user = useSelector((state) => state.UserReducer.user);
  useEffect(() => {
    setCurrentPage(0);
  }, [apiData]);
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [previousId, setPreviousId] = useState(null);
  //const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };

  const storageValue = sessionStorage.getItem(storageKey);
  const savedPage = storageValue !== null ? Number(storageValue) : 0;
  const [currentPage, setCurrentPage] = useState(savedPage);
  useEffect(() => {
    setCurrentPage(savedPage);
  }, [savedPage]);

  const viewDetail = (item) => {
    setViewDetail(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };
  const restorePayment = (item) => {
    setIsRestorePayment(true);
    setSelectedData(item);
    setOpenActionMenu(null);
  };

  const downloadReceipts = (receipt) => {
    window.open(receipt, "_blank");
  };

  const ActionBtns = (item) => {

    const openMenu = (id) => {
      setPreviousId(openActionMenu);
      setOpenActionMenu((prevId) => {
        return prevId === id ? null : id;
      });
    };

    return (
      <ActionBtnWrapper>
        {openActionMenu === item.id && (
          <MenuOptions id="menuOptions">
            <MenuItem
              onClick={() => {
                viewDetail(item)
              }}
            >
              <IoEye className="text-gray-700 " /> View Details
            </MenuItem>
            <MenuItem
              onClick={() => {
                downloadReceipts(item.receipt)
              }}
            >
              <GoDownload className="text-gray-700 " /> Get Receipt
            </MenuItem>
            {item?.canRestore && hasPermission("MANANGE_TRANS_RESTORE", user) &&
              <MenuItem
                onClick={() => {
                  restorePayment(item);
                }}
              >
                <MdRestore className="text-gray-700 " /> Restore
              </MenuItem>
            }
          </MenuOptions>
        )
        }
        <Btn title="Actions" type="button" onClick={() => openMenu(item.id)}>
          <IoMdMore className="text-gray-600" size={24} />
        </Btn>
      </ActionBtnWrapper >
    );
  };

  useEffect(() => {
    if (apiData) {
      const tempData = apiData.map((item) => ({
        name: getName(item),
        room: item.roomNum,
        getPropName: getPropName(item),
        clientName: clientName(item),
        collectionDate: <span className='text-gray-600 text-sm'>{moment(item.collectionDate).format("DD, MMM YY hh:mm A")}</span>,
        amount: getAmount(item),
        mode: getPaymentModeX(getModeName(item.mode), item.recordedBy, item.settleStatus),
        transactionFor1: <span className="text-sm text-gray-600">{item.name}</span>,
        transactionFor: getDesc(item),
        transactionFor2: getTransactionFor(item),
        status: getStatus(item.status),
        //downloadReceipt: downloadReceipt(item),
        action: ActionBtns(item),
      }));
      setData(tempData);
    }
  }, [apiData, openActionMenu]);


  const getDesc = (item) => {
    let transactionFor = getDueTypeLabel(item.transactionFor);
    return (
      <div className="flex flex-col gap-1">
        {/* <span className="text-gray-600 text-sm font-medium">{item?.gId}</span> */}
        <span
          className="text-gray-600 text-sm"
        >
          {transactionFor}
        </span>
        {/* <span
          className="text-gray-400 text-xs"
        >
          {truncateText(item.name, 34)}
        </span> */}
      </div>
    );
  };

  const getPaymentModeX = (mode, recordedBy, settleStatus) => {
    const isKipinn = recordedBy === 'Kipinn App';
    const isSettled = settleStatus === 3;

    return (
      <div className="flex flex-col items-start gap-1">
        <div className="flex items-center gap-1">
          <span className="text-gray-600 text-sm">{mode}</span>

          {isKipinn && (
            <Tooltip
              label={
                isSettled
                  ? 'Amount settled in bank'
                  : 'Amount pending settlement'
              }
            >
              <span
                className={`w-1.5 h-1.5 rounded-full ${isSettled ? 'bg-green-500' : 'bg-amber-500'
                  }`}
              />
            </Tooltip>
          )}
        </div>

        <span className="text-gray-400 text-xs">
          By {truncateText(recordedBy, 30)}
        </span>
      </div>
    );
  };




  // const getPaymentModeX = (mode, recordedBy) => {
  //   return (<div className="flex flex-col gap-0">
  //     <span className="text-gray-600 text-sm">
  //       {mode}{" "}
  //     </span>
  //     {recordedBy && recordedBy === 'Kipinn App' ? <span className="text-primary-color text-xs">{truncateText("By " + recordedBy, 30)}</span>
  //       :
  //       <span className="text-gray-400 text-xs">{truncateText("By " + recordedBy, 30)}</span>
  //     }
  //   </div>);
  // };

  const goToDues = (clickOn, item) => {
    const e = item.isMovedOut ? "1" : "";
    navigate(`/tenantdetails/l/${item.tenantId}/${e}`, {
      state: { data: item },
    });
  };

  const getName = (item) => {
    return <TenantMiniProfile
      tenantId={item.tenantId}
      name={item?.tenantName || ""}
      mobile={item.tenantMobile}
      profilePicture={item.profilePicture}
      kycStatus={item.kycStatus}
      //flatName={`${item.roomNum}, ${item.flatName ? item.flatName + "," : ''} ${item.propName}`}
      flatName={
        <div className="text-xs leading-5">
          <div>Room: {item?.roomNum}</div>
          {item?.flatName &&
            <div>Flat: {item?.flatName}</div>
          }
          <div>Property: {item?.propName}</div>
        </div>
      }
      onClick={() => goToDues('Tenant Info', item)}
    />
  };

  const getPropName = (item) => {
    return (
      <div className="flex flex-col">
        <span className="text-zinc-900 font-medium">{item.propName} </span>
      </div>
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const clientName = (item) => {
    return (
      <div className="flex flex-col gap-[2px]">
        <p className="text-zinc-900 font-semibold">{item.clientName}</p>
        <p className="text-amber-500 text-xs">#{item.clientMobile}</p>
      </div>
    );
  };

  const getAmount = (item) => {
    return (
      <div className="flex flex-col gap-1">
        <Amount>₹{formatAmount(item?.amount)}</Amount>
      </div>
    )
  };

  const getTransactionFor = (item) => {
    if (item.transactionFor === 1) {
      return "Rent";
    } else if (item.transactionFor === 2) {
      return "Security";
    } else if (item.transactionFor === 3) {
      return "Extra Charge";
    } else if (item.transactionFor === 4) {
      return "Other";
    } else {
      return "Dues Settlement";
    }
  };

  const getStatus = (status) => {
    if (status === 1) {
      return <Pending>Pending</Pending>;
    } else if (status === 2) {
      return <Resolve>SUCCESS</Resolve>;
    } else {
      return <Inprogress>FAILED</Inprogress>;
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const columns = React.useMemo(() => {
    if (isMobileView) {
      return [
        {
          Header: "Tenant",
          accessor: "name",
        },

        {
          Header: "Amount",
          accessor: "amount",
        },
      ];
    }
    return [
      {
        Header: "Tenant",
        accessor: "name",
      },

      {
        Header: "Amount",
        accessor: "amount",
      },
      {
        Header: "Type",
        accessor: "transactionFor",
      },
      {
        Header: "Mode",
        accessor: "mode",
      },
      {
        Header: "Date",
        accessor: "collectionDate",
      },
      {
        Header: "Action",
        accessor: "action",
      },
    ];
  }, [isMobileView]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );

  // useEffect(() => {
  //   setPageSize(PaginationLimit);
  // }, []);

  useEffect(() => {
    //setCurrentPage(pageIndex); // Update current page on state change
    sessionStorage.setItem(storageKey, pageIndex);
  }, [pageIndex, storageKey]);

  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${column.isSortedDesc ? "-rotate-90" : "rotate-90"
                          } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()} hasdata={(apiData?.length > 0).toString()}>
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr {...row.getRowProps({ style: { height: "80px" } })} hasdata={(apiData?.length > 0).toString()}>
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                        style={{ maxWidth: "320px" }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>Category:</strong>{" "}
                          {data[rowIndex].transactionFor}
                        </li>
                        <li className="flex gap-2">
                          <strong>Mode:</strong> {data[rowIndex].mode}
                        </li>
                        <li className="flex gap-2">
                          <strong>Date:</strong> {data[rowIndex].collectionDate}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {apiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>

          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75"
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};

// const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const MenuOptions = tw.div`
  absolute bottom-10 right-0 
  py-2 w-44 
  bg-white 
  z-50 
  rounded-lg 
  shadow-xl 
  border border-gray-200
`;

// const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-normal cursor-pointer hover:bg-gray-100`;
const MenuItem = tw.div`
  flex items-center gap-2 
  px-4 py-2 
  text-sm 
  cursor-pointer 
  hover:bg-gray-50
`;

const UserImageWrapper = tw.div` flex items-center gap-2 cursor-pointer w-full min-w-0`;
const UserImage = tw.img`w-9 h-9 rounded-full `;


const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
// const ActionBtnWrapper = tw.div`grid xl:grid-cols-2 md:grid-cols-1 grid-cols-4 w-40 mb-1 gap-y-1 gap-x-1.5 md:w-16 mt-3 md:mt-0`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-gray-600 bg-blue-50`;
const Tbody = tw.tbody`${(props) => (props.hasdata === "true" ? "border-b" : "")}`;
// const Tr = tw.tr`${(props) =>
//   props.hasdata === "true"
//     ? "border-b"
//     : ""} rounded-md overflow-hidden hover:bg-slate-50`;
const Tr = tw.tr`
  border-b last:border-b-0
  hover:bg-slate-50 
  transition-colors 
`;

const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-normal text-gray-600`;

//const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Td = tw.td`
  p-3 text-sm 
  align-middle
`;
// const Btn = tw.button`grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const Pending = tw.div`bg-blue-100 text-blue-700 text-xs border-blue-300 border w-24 h-7 flex items-center justify-center rounded`;
const Inprogress = tw.div`bg-yellow-100 text-yellow-700 text-xs border-yellow-300 border w-24 h-7 flex items-center justify-center rounded`;
const Resolve = tw.div`bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded`;
//const Amount = tw.p`text-gray-700 text-sm flex font-medium`;
const Amount = tw.p`
  text-gray-900 
  text-sm 
  font-semibold 
  tabular-nums
`;
export default TransactionTable;
